module.exports = "<p>\n  register works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/user/register/register.component.html
// module id = ../../../../../src/app/user/register/register.component.html
// module chunks = main